import { useMemo } from 'react';
import { QueryResult, useQuery, QueryConfig } from 'react-query';
import { County, RefDataStateApi, State } from 'eve-account-client';
import { titleCase } from 'title-case';
import { useConfiguration } from './BaseApi';

export const useRefDataStatesApi = (): RefDataStateApi => {
  const configuration = useConfiguration();
  const api = useMemo(() => new RefDataStateApi(configuration), [configuration]);
  return api;
};

const getStates = async (api: RefDataStateApi): Promise<State[]> => {
  const request = api.getStates({});
  // TODO: Format on the backend or in the database.
  return (await request).map(
    (state): State => ({
      ...state,
      displayName: titleCase(state.displayName.toLowerCase()),
    }),
  );
};

export const useStatesQuery = (
  queryOptions?: QueryConfig<State[], Error | Response>,
): QueryResult<State[], Error | Response> => {
  const api = useRefDataStatesApi();

  return useQuery<State[], Error | Response>(['states'], () => getStates(api), queryOptions);
};

const getCounties = async (stateCode: string, api: RefDataStateApi): Promise<County[]> => {
  const request = api.getCounties({ stateCode });

  // TODO: Format on the backend or in the database.
  return (await request).map(
    (county): County => ({
      ...county,
      displayName: titleCase(county.displayName.toLowerCase()),
    }),
  );
};

export const useCountiesQuery = (stateCode?: string): QueryResult<County[], Error | Response> => {
  const api = useRefDataStatesApi();

  return useQuery<County[], Error | Response>(['counties', stateCode], () => getCounties(stateCode as string, api), {
    enabled: Boolean(stateCode),
  });
};
